<template>
  <div class="d-flex align-items-center justify-content-center px-4 py-10 h-100">
    <div class="rounded card d-flex flex-column justify-content-center align-items-center gap-4 h-75 py-10 px-6 col-xl-3 col-lg-6 col-md-7 col-sm-9">
      <template>
        <component :is="icons[errorCode]" :class="iconsClasses[errorCode]" size="3x"/>
        <h3 class="text-2xl font-weight-bolder m-0">
          {{ $t(title[errorCode]) }}
        </h3>
        <p class="text-subdued m-0" v-html="$t(description[errorCode])"></p>
        <b-button round pill size="sm" variant="info" @click="$router.replace({ name: 'vacancy-search' })">
          {{ $t("vacancy.actions.seeAllVacancies") }}
        </b-button>
      </template>
    </div>
  </div>
</template>

<script>
import { ShieldExclamationIcon } from "@vue-hero-icons/outline";
import { ExclamationCircleIcon } from "@vue-hero-icons/solid";

export default {
  components: {
    ExclamationCircleIcon,
    ShieldExclamationIcon,
  },
  props: {
    code: {
      type: Number | String,
      default: 404,
    },
  },
  setup() {
    const icons = {
      404: "ExclamationCircleIcon",
      410: "ExclamationCircleIcon",
    };

    const iconsClasses = {
      404: "text-warning",
      410: "text-warning",
    };

    const title = {
      404: "errors.vacancy.not-found",
      410: "errors.vacancy.expired",
    };

    const description = {
      404: "errors.vacancy.not_found_description",
      410: "errors.vacancy.expired_description",
    };

    return {
      icons,
      iconsClasses,
      title,
      description,
    };
  },
  computed: {
    errorCode() {
      const supported = [404, 410];
      return supported.includes(Number(this.code)) ? Number(this.code) : 404;
    },
  },
};
</script>
